import ChildTerm from "../templates/childTerm.js";
import ParentTerm from "../templates/parentTerm.js";
import setChiclet from "../helpers/chiclet.js";
import createId from "../helpers/generateId.js";
import modalSearch from "../helpers/modalSearch.js";

const taxonomyModalWidget = instantsearch.connectors.connectRefinementList(
	(
		{ widgetParams, canRefine, items, createURL, refine, helper,
		searchForItems, isFromSearch },
		isFirstRender
	) => {
		const tax = widgetParams.taxonomy;

		if ( ! brookingsAlgoliaFeedOptions.facets.includes(`${tax}s`) ) {
			return;
		}

		const container = document.getElementById(`${tax}-filter-modal`);
		const parents = [];
		const children = [];

		if (isFirstRender) {
			document.querySelector(`#${tax}Facets`).classList.add('active');

			container.addEventListener("click", ({ target }) => {
				const input = target.closest(
					'input[type="checkbox"]'
				);

				if (input) {
					refine(input.value);
				}
			});

			// container.addEventListener("input", ({ target }) => {
			// 	const isSearchInput =
			// 		target.nodeName === "INPUT" &&
			// 		target.type === "search";

			// 	if (isSearchInput) {
			// 		searchForItems(target.value);
			// 	}
			// });

			return;
		}

		modalSearch(container);

		if (!isFromSearch) {
			// this enables the algolia facet search functionality. But 
			// we're using custom facet search functionality instead.
			// container.querySelector(`#liveSearch-${tax}`).value = "";
		}

		// iterate over items
		items.forEach((item) => {
			// create a new array of term objects
			let tmtermType = `${tax}Terms`;
			const tmTerms = JSON.parse(brookingsAlgolia[tmtermType]);
			
			// find matching object with name property in the brookingsAlgolia.terms array
			const topicTerm = tmTerms.find(
				(term) => term.id == item.value
			);			

			if ( ! topicTerm ) {
				return;
			}

			item.label = topicTerm.name;
			item.id = createId( topicTerm.name );
			item.term_id = topicTerm.id;

			if (topicTerm.parent === 0) {
				parents.push(item);
			} else {
				children.push({
					parent: topicTerm.parent,
					item: item,
				});
			}
		});

		let orphans = [];

		if ( parents.length == 0 ) {
			let childrenFilterHtml = "";
			children.forEach((child) => {
				if (child.parent === parent.label) {
					childrenFilterHtml += ChildTerm(child);
					// check if child is in orphans, and if so, remove it
					const index = orphans.indexOf(child);
					if (index > -1) {
						orphans.splice(index, 1);
					}
				} else {
					// check if child is in orphans, and if not, add it
					if (orphans.indexOf(child) === -1) {
						orphans.push(child);
					}
				}
			});
		}

		// iterate over parents, and add additional parents for orphaned children
		parents.forEach((parent) => {
			let childrenFilterHtml = "";
			children.forEach((child) => {
				if (child.parent === parent.label) {
					childrenFilterHtml += ChildTerm(child);
					// check if child is in orphans, and if so, remove it
					const index = orphans.indexOf(child);
					if (index > -1) {
						orphans.splice(index, 1);
					}
				} else {
					if (orphans.indexOf(child) === -1) {
						orphans.push(child);
					}
				}
			});
		});

		// if orphans exist, add them to the parent
		if (orphans.length > 0) {
			orphans.forEach((orphan) => {
				// check if a parent already exists for this orphan
				const parentExists = parents.find(
					(parent) => parent.label === orphan.parent
				);
				if ( parentExists ) {
					// if parent exists, add the child to the parent
					parentExists.children += ChildTerm(orphan);
					return;
				}

				parents.push({
					label: orphan.parent,
					value: 0,
					id: createId(orphan.parent),
					isRefined: false,
					count: 0,
					term_id: 0,
					children: ChildTerm(orphan)
				});
			});
		}

		// iterate over parents, and if there are children, add them to the html
		parents.forEach((parent) => {
			let childrenFilterHtml = "";
			children.forEach((child) => {
				if (child.parent === parent.label) {
					childrenFilterHtml += ChildTerm(child);
				}
			});
			parent.children = childrenFilterHtml;
		});

		container.querySelector(`#${tax}typeFiltersContainer`).innerHTML =
			parents
				.map(
					({
						value,
						id,
						isRefined,
						label,
						highlighted,
						count,
						children,
						term_id
					}) => ParentTerm({
						value,
						id,
						isRefined,
						label,
						highlighted,
						count,
						children,
						term_id
					})
				)
				.join("");

		if ( ! isFirstRender ) {
			// clear .search-field
			const searchField = document.querySelector(`#${tax}-filter-modal .search-field`);
			// on .form-checkbox click, clear searchField value
			const formCheckboxes = document.querySelectorAll(`#${tax}-filter-modal .form-checkbox`);
			formCheckboxes.forEach((formCheckbox) => {
				formCheckbox.addEventListener('click', () => {
					searchField.value = '';
				});
			});
			// Expand toggles if any sub-filter is checked
			const subFilters = document.querySelectorAll('.sub-filters');
			subFilters.forEach((subFilter) => {
				const inputs = subFilter.querySelectorAll('input[type="checkbox"]');
				if (inputs.length > 0) {
					inputs.forEach((input) => {
						if ( input.checked || searchField.value !== '' ) {
							const parentItem = input.closest('.item-parent');
							if ( parentItem ) {
								const toggle = parentItem.querySelector('.sub-filters');
								if ( toggle ) {
									toggle.removeAttribute('hidden');
								}
							}
						}
					});
				}
			});

			if ( items.length > 0 ) {
				items.forEach( (item) => {
					setChiclet(item,widgetParams.attribute,refine);
				});
			}
		}
	}
);

export default taxonomyModalWidget